<template>
  <transition name="bounce">
    <div class='YModal-warp' @click.self="outsideClosable ? close() : ''" v-if="show">
      <div class="YModal">
        <div class="header">
          <div class="title" v-if="title">{{title}}</div>
          <div class="close" v-if="closable"><i @click="close" class="el-icon-close"></i></div>
        </div>
        <div class="main">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'YModal',

  props: {
    title: {
      type: String,
      default: ''
    },

    show: {
      type: Boolean,
      default: false
    },

    closable: {
      type: Boolean,
      default: true
    },

    outsideClosable: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {}
  },

  methods: {
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang='stylus' scoped>
  .YModal-warp
    position fixed
    height 100%
    width 100%
    left 0
    top 0
    background rgba(0, 0, 0, .3)
    display flex
    justify-content center
    align-items center
    .YModal
      min-width 500px
      min-height 300px
      background #ffffff
      border-radius 20px
      padding 20px
      position relative
      display flex
      flex-direction column
      .header
        display flex
        align-items center
        justify-content center
        .title
          font-size 22px
          font-weight bold
          line-height 22px
          margin-bottom 20px
        .close
          position absolute
          font-size 22px
          font-weight bold
          cursor pointer
          right 15px
          top 10px
          &:hover
            color #409EFF
      .main
        flex auto
</style>
